import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  RowWrapper,
  Section,
  SectionTitle,
  UserFormProps,
} from '../../../components/AdminFormComponents';

export const WeeklyReportUserSection = (props: UserFormProps) => {
  const { t } = useTranslation();
  const { values, setFieldValue, isSubmitting } = props;

  return (
    <Section id='weeklyReportUserSection'>
      <SectionTitle>{t('Weekly Report')}</SectionTitle>
      <RowWrapper>
        <FormikSwitchField
          extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
          name='weeklyReportEnabled'
          label={t('Enable Weekly Report')}
          onChange={() => {
            setFieldValue(`weeklyReportEnabled`, !values.weeklyReportEnabled);
          }}
          readOnly={isSubmitting}
        />
      </RowWrapper>
    </Section>
  );
};
